import { ComputedRef, InjectionKey, Ref } from 'vue'
import { User } from '../../libs/models'

export const drawnKey: InjectionKey<Ref<boolean>> = Symbol()
export const currentUserKey: InjectionKey<Ref<User>> = Symbol()
export const modalsKey: InjectionKey<Ref<symbol[]>> = Symbol()
export const isEnteredKey: InjectionKey<ComputedRef<boolean>> = Symbol()
export const tabNameKey: InjectionKey<Ref<string>> = Symbol()
export const openNewUserModalKey: InjectionKey<() => void> = Symbol()
export const openOptionsModalKey: InjectionKey<() => void> = Symbol()
